import { Backdrop, Box, CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../../layout/Layout";
import EventsCard from "../../../components/Events/EventsCard";
import EventFilters from "../../../components/Events/EventFilters";
import CustomTabs from "../../../components/Common/CustomTabs";
import CreateEventModal from "../../../components/Modals/CreateEventModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { useDispatch, useSelector } from "react-redux";
import { getAllEvents } from "../../../redux/dispatchers/events.dispatcher";
import dayjs from "dayjs";

const tabsData = [
  { id: 2, name: "Upcoming" },
  { id: 3, name: "Past" },
];

const Events = () => {
  const dispatch = useDispatch();
  const { upcomingEvents, pastEvents } = useSelector((state) => state.events);

  const [tabState, setTabState] = useState("Upcoming");

  const [date, setDate] = useState(null);
  const [eventType, setEventType] = useState("");
  const [ticketingType, setTicketingType] = useState("");
  const [eventLocation, setEventLocation] = useState("");

  const [createEventModal, setCreateEventModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    errorMsg: "",
  });

  useEffect(() => {
    dispatch(getAllEvents());
  }, []);

  const allEvents = tabState === "Upcoming" ? upcomingEvents : pastEvents;

  const filteredEvents = allEvents?.filter((event) => {
    const eventDate = event?.event_date;
    const selectedDate = dayjs(date).format("YYYY-MM-DD") || null;
    const isDateMatch = selectedDate ? eventDate === selectedDate : true;
    const isTypeMatch = eventType ? event?.event_type === eventType : true;
    const isLocationMatch = eventLocation
      ? event?.location === eventLocation
      : true;
    const isTicketingMatch = ticketingType
      ? event?.ticketing_option === ticketingType
      : true;

    return isDateMatch || isTypeMatch || isLocationMatch || isTicketingMatch;
  });

  return (
    <Layout
      heading="Events"
      hideSideBar={createEventModal}
      onCreate={() => setCreateEventModal(true)}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="Event Created Successfully"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item size={{ xs: 12, md: 5 }}>
            <EventFilters
              setDate={setDate}
              setEventType={setEventType}
              setEventLocation={setEventLocation}
              setTicketingType={setTicketingType}
              date={date}
              eventType={eventType}
              eventLocation={eventLocation}
              ticketingType={ticketingType}
            />
          </Grid>
          <Grid item size={{ xs: 12, md: 7 }}>
            <CustomTabs
              data={tabsData}
              setTabState={setTabState}
              tabState={tabState}
            />
            {filteredEvents?.map((event) => (
              <EventsCard item={event} key={event?.id} />
            ))}
          </Grid>
        </Grid>

        <CreateEventModal
          open={createEventModal}
          onClose={() => setCreateEventModal(false)}
          setLoading={setLoading}
          setErrorState={setErrorState}
          setSuccess={setSuccess}
        />
      </Box>
    </Layout>
  );
};

export default Events;
